<template>
  <div
    class="container-fluid d-print-block report_table p-0"
    style="background-color:#f2f2f2;font-family: Source Sans Pro; overflow: visible;margin-left: 11px !important;"
  >
    <div class="d-print-block" style="background-color:#f2f2f2;border:none; margin-bottom: 50px;">
      <div
        class="card-body d-print-block"
        style="font-family: Source Sans Pro;font-style: normal;font-weight: normal;font-size: 14px;line-height: 18px;color: #29342E;"
      >
        <div id="card" ref="report" class="d-print-block print">
          <div class="row d-print-block">
            <!-- FIRST CARD: LOGO, STATUS AND GENERAL INFO -->
            <div class="col-12 card" style="margin-top: -12px">
              <div id="report">Preview Report</div>
              <hr id="first_hr" />

              <table id="mid_table" align="right">
                <tr>
                  <td style="width:100%"></td>
                  <td>
                    <span id="powerd_by">powered by</span>
                  </td>
                  <td style="padding-left:0px;">
                    <img class="Agsift-logo" src="@/assets/img/AgsiftLogo.png" alt="Agsift" />
                  </td>
                </tr>
              </table>
              <table class="table table-Logo table-borderless col-12" style="margin-top:-2%;">
                <tbody>
                  <tr class>
                    <td class="text-center" colspan="2">
                      <img
                        class="report-logo"
                        src="@/assets/img/ALsumLogo.png"
                        alt="alsum logo"
                        crossorigin="anonymous"
                        style="margin-bottom:40px;"
                      />
                    </td>
                  </tr>
                </tbody>
              </table>

              <div>
                <div>
                  <ul
                    class="nav nav-pills nav-justified d-print-block"
                    id="inspection_role"
                    role="tablist"
                  >
                    <li class="nav-item waves-effect waves-light d-print-block">
                      <a
                        class="nav-link active width200 singleLink text-center"
                        role="tab"
                      >Inspection Report</a>
                    </li>
                  </ul>
                </div>
                <!-- REPORT STATUS -->
                <!-- <center>
                  <div class="col-2">
                    <span class="first_str" style="text-align:center;">Status :</span>
                    <span id="approved_name">
                      <span v-if="weighted_status === 'Passed'" class="passed">Passed</span>
                      <span v-else-if="weighted_status === 'Failed'" class="failed">Failed</span>
                      <span v-else class="borderline">Borderline</span>
                    </span>
                  </div>
                </center>-->
                <!-- REPORT STATUS END -->
                <!-- GENERAL INFORMATION -->
                <div class="table_top">
                  <table class="table-borderless table-generalInfo" style="margin-bottom:24px;">
                    <tbody>
                      <tr>
                        <td class="tdleft col-5">
                          <span class="header-title first_str">Grower/Shipper :</span>
                          <span class="tdleft">{{ reports.generalInfo.grower }}</span>
                        </td>
                        <td class="col"></td>
                        <td class="tdright col-5">
                          <span class="header-title first_str">Inspection Date :</span>
                          <span class="tdright">{{getDate(reports.generalInfo.inspection_time)}}</span>
                        </td>
                      </tr>

                      <tr>
                        <td class="tdleft">
                          <span class="header-title first_str">Consignment Number :</span>
                          <span class="tdleft">{{ reports.generalInfo.consignment_num }}</span>
                        </td>
                        <td class="col"></td>
                        <td class="tdright">
                          <span class="header-title first_str">Inspection Time :</span>
                          <span class="tdright">{{getTime(reports.generalInfo.inspection_time)}}</span>
                        </td>
                      </tr>

                      <tr>
                        <td class="tdleft">
                          <span class="header-title first_str">Purchase Order :</span>
                          <span class="tdleft">{{ reports.generalInfo.purchase_order }}</span>
                        </td>
                        <td class="col"></td>
                        <td class="tdright">
                          <span class="header-title first_str">Inspector Name :</span>
                          <span class="tdright">{{ reports.generalInfo.inspector_name}}</span>
                        </td>
                      </tr>
                      <tr>
                        <td class="tdleft">
                          <span class="header-title first_str">Item Number :</span>
                          <span class="tdleft">{{ reports.generalInfo.item_no }}</span>
                        </td>
                        <td class="col"></td>
                        <td class="tdright">
                          <span class="header-title first_str">Commodity :</span>
                          <span class="tdright">{{ reports.generalInfo.commodity}}</span>
                        </td>
                      </tr>
                      <tr>
                        <td class="tdleft">
                          <span class="header-title first_str">Ordered Quantity :</span>
                          <span class="tdleft">{{ reports.generalInfo.ordered_quantity}}</span>
                        </td>
                        <td class="col"></td>
                        <td class="tdright">
                          <span class="header-title first_str">Variety :</span>
                          <span class="tdright">{{ reports.generalInfo.variety}}</span>
                        </td>
                      </tr>
                      <tr>
                        <td class="tdleft">
                          <span class="header-title first_str">Weight/Quantity Received :</span>
                          <span class="tdleft">{{ reports.generalInfo.recieved_quantity}}</span>
                        </td>
                        <td class="col"></td>
                        <td class="tdright">
                          <span class="header-title first_str">Production Process Code :</span>
                          <span class="tdright">{{ reports.generalInfo.package_type}}</span>
                        </td>
                      </tr>
                      <tr>
                        <td class="tdleft">
                          <span class="header-title first_str">No. of Samples :</span>
                          <span class="tdleft">{{ reports.generalInfo.num_samples}}</span>
                        </td>
                        <td class="col"></td>
                        <td class="tdright">
                          <span class="header-title first_str">Inspection Type :</span>
                          <span class="tdright">{{ reports.generalInfo.inspection_type}}</span>
                        </td>
                      </tr>
                    </tbody>
                  </table>
                </div>
                <!-- GENERAL INFORMATION END -->
              </div>
            </div>
            <!-- FIRST CARD END -->
            <br />
            <!-- SECOND CARD ALLOWANCE -->
            <div class="col-12 card" style="margin-top:16px;">
              <div class="row">
                <div class="col heading_2" style="margin-top:16px;">Allowance</div>
              </div>
              <hr style="border: 1px solid #CACACA;margin-bottom:16px;" />
              <div class="row">
                <div class="table-responsive" style="padding-left: 15px;padding-right: 15px;">
                  <table class="table table-bordered">
                    <thead>
                      <tr
                        style="background: #F2F2F2;border: 1px solid #CACACA;box-sizing: border-box;border-radius: 4px;"
                      >
                        <th style="width: 128px;font-weight: 600;border: 1px solid #CACACA;">Samples</th>
                        <th style="width: 118px;font-weight: 600;border: 1px solid #CACACA;">
                          Weight
                          <br />(lb)
                        </th>
                        <th
                          style="width: 118px; font-weight: 600;border: 1px solid #CACACA;"
                        >Pulp Temp.(&deg;F)</th>
                        <th style="font-weight: 600;border: 1px solid #CACACA;">Type</th>
                        <th style="width: 118px;font-weight: 600;border: 1px solid #CACACA;">
                          Damage
                          <br />(%)
                        </th>
                        <th style="width: 141px;font-weight: 600;border: 1px solid #CACACA;">
                          Serious
                          <br />Damage (%)
                        </th>
                        <th style="width: 88px;font-weight: 600;">
                          Status
                          <br />(%)
                        </th>
                      </tr>
                    </thead>
                    <tbody v-for="(item, index) in reports.allowances" :key="index">
                      <tr v-if="index!=0">
                        <td colspan="7" class="blank-row"></td>
                      </tr>

                      <tr v-if="!item.values.length">
                        <td colspan="1">{{item.name}}</td>
                        <td colspan="1">{{item.sample_weight}}</td>
                        <td>{{item.pulp_temperature}}</td>
                        <td>No Allowances Found</td>
                        <td>-</td>
                        <td>-</td>
                        <td :class="['td-defect-items','text-green']">Passed</td>
                      </tr>
                      <tr v-for="(al,idx) in item.values" :key="idx">
                        <!-- Row With Sample Name -->
                        <td v-if="idx==0" :rowspan="item.values.length" colspan="1">{{item.name}}</td>
                        <td
                          v-if="idx==0"
                          :rowspan="item.values.length"
                          colspan="1"
                        >{{item.sample_weight}}</td>
                        <td v-if="idx==0" :rowspan="item.values.length">{{item.pulp_temperature}}</td>
                        <!-- Row without Sample Name -->
                        <td colspan="1" class="td-defect-items">{{al.name}}</td>
                        <td
                          class="td-defect-items"
                        >{{al.damage==0?'-':Math.round(al.damage*100)/100+'%'}}</td>
                        <td
                          class="td-defect-items"
                        >{{al.seriousDamage==0?'-':Math.round(al.seriousDamage*100)/100+'%'}}</td>
                        <td
                          :class="['td-defect-items',(al.status)?'text-green':'text-red']"
                        >{{al.status?"Passed":"Failed"}}</td>
                        <!-- Row with Defect head Ends -->
                      </tr>
                      <tr v-if="item.values.length">
                        <td colspan="4" class="text-center">
                          <span class="bold">Combined Allowance</span>
                          ({{item.combinedAllowance.map(al=>al.substr(0,10)).join(', ')}})
                        </td>
                        <td>{{Math.round(item.combinedDamage *100)/100}}%</td>
                        <td>{{Math.round(item.combinedSeriousDamage *100)/100}}%</td>
                        <td
                          :class="['td-defect-items',(item.combinedStatus)?'text-green':'text-red']"
                        >{{item.combinedStatus?"Passed":"Failed"}}</td>
                      </tr>
                    </tbody>
                  </table>
                </div>
              </div>
            </div>
            <!-- SECOND CARD END -->

            <!-- THIRD CARD DEFECT -->
            <div class="col-12 card" style="margin-top:16px;">
              <div class="row">
                <div class="col heading_2" style="margin-top:16px;">Defects</div>
              </div>
              <hr style="border: 1px solid #CACACA;margin-bottom:16px;" />
              <div class="row">
                <div class="table-responsive" style="padding-left: 15px;padding-right: 15px;">
                  <table class="table table-bordered">
                    <tbody>
                      <tr
                        style="background: #F2F2F2;border: 1px solid #CACACA;box-sizing: border-box;border-radius: 4px;"
                      >
                        <th style="width: 128px;font-weight: 600;border: 1px solid #CACACA;">Samples</th>
                        <th style="width: 118px;font-weight: 600;border: 1px solid #CACACA;">
                          Weight
                          <br />(lb)
                        </th>
                        <th
                          style="width: 118px; font-weight: 600;border: 1px solid #CACACA;"
                        >Pulp Temp.(&deg;F)</th>
                        <th style="font-weight: 600;border: 1px solid #CACACA;">Type</th>
                        <th style="width: 118px;font-weight: 600;border: 1px solid #CACACA;">
                          Damage
                          <br />(%)
                        </th>
                        <th style="width: 141px;font-weight: 600;border: 1px solid #CACACA;">
                          Serious
                          <br />Damage (%)
                        </th>
                        <th style="width: 88px;font-weight: 600;">
                          Total
                          <br />(%)
                        </th>
                      </tr>
                      <tr v-for="(item, index) in defects" :key="index">
                        <!--#region CheckSum Row -->
                        <td
                          v-if="item.rowType==4"
                          rowspan="1"
                          colspan="4"
                          v-bind:class="['text-center',item.status=='Failed'?'border-new':'border-new']"
                        >
                          <span class="bold">Defects Percentage</span>
                          ({{item.samName}})
                        </td>
                        <td
                          v-if="item.rowType==4"
                          v-bind:class="['damage_values',item.status=='Failed'?'border-new':(item.status=='Passed'?'border-new':'border-new')]"
                        >{{item.D==0?'-':Math.round(item.D*100)/100+'%'}}</td>
                        <td
                          v-if="item.rowType==4"
                          v-bind:class="['damage_values',item.status=='Failed'?'border-new':(item.status=='Passed'?'border-new':'border-new')]"
                        >{{item.SD==0?'-':Math.round(item.SD*100)/100+'%'}}</td>
                        <td
                          v-if="item.rowType==4"
                          v-bind:class="[item.status=='Failed'?'border-new text-red':(item.status=='Passed'?'text-green border-new':'text-yellow border-new')]"
                        >{{Math.round(item.Tot*100)/100+'%'}}</td>
                        <!-- CheckSum Row End-->
                        <!-- Blank Row -->
                        <td v-if="item.rowType==0" rowspan="1" colspan="7" class="blank-row"></td>
                        <!-- Blank Row End -->
                        <!-- Row With Sample Name -->
                        <td
                          v-if="item.rowType==1"
                          :rowspan="item.rowSpan"
                          colspan="1"
                        >{{item.samName}}</td>
                        <td
                          v-if="item.rowType==1"
                          :rowspan="item.rowSpan"
                          colspan="1"
                        >{{item.samWT}}</td>
                        <td
                          v-if="item.rowType==1"
                          :rowspan="item.rowSpan"
                          colspan="1"
                        >{{item.pulp_temperature}}</td>
                        <!-- Row without Sample Name -->
                        <td
                          v-if="item.rowType==1||item.rowType==2||item.rowType==5"
                          :rowspan="item.isLastRow?1:1"
                          colspan="1"
                          class="td-defect-items"
                        >{{item.DefItem}}</td>
                        <td
                          v-if="item.rowType==1||item.rowType==2||item.rowType==5"
                          :rowspan="item.isLastRow?1:1"
                          colspan="1"
                          class="td-defect-items"
                        >{{item.DItem==0?'-':Math.round(item.DItem*100)/100+'%'}}</td>
                        <td
                          v-if="item.rowType==1||item.rowType==2||item.rowType==5"
                          :rowspan="item.isLastRow?1:1"
                          colspan="1"
                          class="td-defect-items"
                        >{{item.SDItem==0?'-':Math.round(item.SDItem*100)/100+'%'}}</td>
                        <td
                          v-if="item.rowType==1||item.rowType==2||item.rowType==5"
                          :rowspan="1"
                          colspan="1"
                          :class="['td-defect-items',(item.status)?'text-green':'text-red']"
                        >{{Math.round(item.TotItem * 100) / 100}}%</td>
                        <!-- Row with Defect head Ends -->
                      </tr>

                      <tr>
                        <td
                          v-bind:class="[(reports.averageCheckSum.DefectStatus!='Failed')?((reports.averageCheckSum.DefectStatus!='Border')?'text-green border-green':'text-yellow border-yellow'):'text-red border-red','heading','text-center', 'bold']"
                          colspan="4"
                        >Average Defects Percentage</td>

                        <td
                          v-bind:class="[(reports.averageCheckSum.DefectStatus!='Failed')?((reports.averageCheckSum.DefectStatus!='Border')?'text-green border-green':'text-yellow border-yellow'):'text-red border-red']"
                        >{{Math.round(reports.averageCheckSum.damage*100)/100}}%</td>
                        <td
                          v-bind:class="[(reports.averageCheckSum.DefectStatus!='Failed')?((reports.averageCheckSum.DefectStatus!='Border')?'text-green border-green':'text-yellow border-yellow'):'text-red border-red']"
                        >{{Math.round(reports.averageCheckSum.seriousDamage*100)/100}}%</td>
                        <td
                          v-bind:class="[(reports.averageCheckSum.DefectStatus!='Failed')?((reports.averageCheckSum.DefectStatus!='Border')?'text-green border-green':'text-yellow border-yellow'):'text-red border-red','damage_values']"
                        >{{Math.round(reports.averageCheckSum.total*100)/100}}%</td>
                      </tr>
                    </tbody>
                  </table>
                </div>
              </div>
            </div>
            <!-- THIRD CARD END -->
            <br />
            <!-- FORTH CARD : BASIC REQUIREMENTS-->
            <div v-if="!hideBasicRequirements" class="col-12 card" style="margin-top:16px;">
              <div class="row">
                <div class="col heading_2" style="margin-top:16px;">Basic Requirements</div>
              </div>
              <hr />
              <div class="row">
                <div class="table-responsive" style="padding-left: 15px;padding-right: 15px;">
                  <table class="table table-bordered">
                    <tbody>
                      <tr class="ro">
                        <th>Samples</th>
                        <th class>Cleaness</th>
                        <th class>Shape</th>
                        <th class>Cureness</th>
                        <th class>Brightness</th>
                        <th class>Skinning</th>
                      </tr>
                      <tr v-for="(item, index) in reports.basicRequirements" :key="index">
                        <td>{{item.name}}</td>
                        <td v-if="item.cleanness!==''">{{item.cleanness}}</td>
                        <td v-else>N/A</td>
                        <td v-if="item.shape!==''">{{item.shape}}</td>
                        <td v-else>N/A</td>
                        <td v-if="item.cureness!==''">{{item.cureness}}</td>
                        <td v-else>N/A</td>
                        <td v-if="item.brightness!==''">{{item.brightness}}</td>
                        <td v-else>N/A</td>
                        <td v-if="item.skinning!==''">{{item.skinning}}</td>
                        <td v-else>N/A</td>
                      </tr>
                    </tbody>
                  </table>
                </div>
              </div>
            </div>
            <!-- FORTH CARD END -->
            <!-- FIFTH CARD: SIZEDESIGNATION -->
            <div class="card col-12">
              <div class="row">
                <div class="col heading_2" style="margin-top:16px; ">Size Designation</div>
              </div>
              <hr />
              <div class="row">
                <div class="col-12">
                  <table class="table table-bordered">
                    <tbody>
                      <tr class="back-color">
                        <th>Sample Number</th>
                        <th>Size Designation</th>
                        <th>
                          Minimum Diameter
                          <br />(in/mm)
                        </th>
                        <th>
                          Maximum Diameter
                          <br />(in/mm)
                        </th>
                        <th>Size(%)</th>
                        <th>Status</th>
                      </tr>

                      <tr v-for="(item, index) in reports.sizeDesignation" :key="index">
                        <td class="heading">{{ item.name }}</td>
                        <td v-if="item.sizeRange">{{item.sizeRange}}</td>
                        <td v-else>N/A</td>
                        <td v-if="item.minDiameter">{{ item.minDiameter }} {{ item.unit }}</td>
                        <td v-else>N/A</td>
                        <td v-if="item.maxDiameter">{{ item.maxDiameter }} {{ item.unit }}</td>
                        <td v-else>N/A</td>
                        <td>
                          <span>
                            <span class="font-weight-bold">UnderSize:&nbsp;</span>
                            {{item.underSize}}%
                          </span>
                          <span v-if="item.hasoverSize">
                            <br />
                            <span class="font-weight-bold">OverSize:&nbsp;</span>
                            {{item.overSize}}%
                          </span>
                          <span v-if="item.hasSizeA">
                            <span class="font-weight-bold">
                              <br />Weight:&nbsp;
                            </span>
                            {{item.weight}}%
                          </span>
                        </td>
                        <td
                          v-bind:class="[item.status?'text-green border-new':'border-new text-red']"
                        >{{item.status?"Passed":"Failed"}}</td>
                      </tr>
                    </tbody>
                  </table>
                </div>
              </div>
            </div>
            <!-- FIFTH CARD END -->
            <br />
            <!-- SIXTH CARD SUMMARY -->
            <div class="col-12 card">
              <div class="row">
                <div class="col heading_2" style="margin-top:16px; ">Summary</div>
              </div>
              <hr />
              <div
                v-if="reports.averageCheckSum.status=='Passed'"
                class="status"
                style="color : #24C656; background: #E0F7EA; border: 1px solid #3CB371 !important; border-radius: 5px; font-weight: bold;"
              >
                <img class="image_svg" src="@/assets/icons/circle.svg" alt="Tick" />
                Report Passed, Weighted Avg total is
                <span
                  style="font-weight:bolder"
                >{{Math.round(reports.averageCheckSum.total*100)/100}}%</span>
                and Allowance Passed
              </div>
              <div
                v-else-if="reports.averageCheckSum.status=='Failed'"
                class="status"
                style="color : #E74C3C;; background:#FCE6E4; border: 1px solid #E74C3C; border-radius: 5px; font-weight: bold;"
              >
                <img class="image_svg" src="@/assets/icons/Cross.svg" alt="Cross" />
                Report failed, Weighted Avg total is
                <span
                  style="font-weight:bolder"
                >{{Math.round(reports.averageCheckSum.total*100)/100}}%</span>
                and Allowance
                <span
                  v-if="reports.averageCheckSum.AllowanceStatus"
                >Passed.</span>
                <span v-else>Failed.</span>
              </div>
              <div
                v-else
                class="status"
                style="color :#F0A623; background:#FDF2DE; border: 1px solid #F0A623; border-radius: 5px; font-weight: bold;"
              >
                <img class="image_svg" src="@/assets/icons/warming.svg" alt="Warming" />
                Report Borderline, Weighted Avg total is
                <span
                  style="font-weight:bolder"
                >{{Math.round(reports.averageCheckSum.total*100)/100}}%.</span>
                and Allowances Passed.
              </div>
              <div class="top_up" v-for="(item,index) in reports.defects" :key="index">
                <div v-if="item.checkSum.status=='Passed'" class="status" style="color : #24C656; ">
                  <span class="side_text">{{item.name}}</span> Passed, Total defects
                  <span
                    style="font-weight:bolder"
                  >{{Math.round(item.checkSum.total*100)/100}}%</span>
                  is below threshold {{reports.averageCheckSum.threshold.totalDamageThreshold}}%
                </div>
                <div
                  v-else-if="item.checkSum.status=='Failed'"
                  class="status"
                  style="color : #E74C3C;"
                >
                  <span class="side_text">{{item.name}}</span> Failed, Total defects
                  <span
                    style="font-weight:bolder"
                  >{{Math.round(item.checkSum.total*100)/100}}%</span>
                  is
                  <span
                    v-if="reports.averageCheckSum.DefectStatus=='Passed'"
                  >below</span>
                  <span v-else-if="reports.averageCheckSum.DefectStatus=='Failed'">above</span>
                  <span v-else>vlose</span>
                  threshold {{reports.averageCheckSum.threshold.totalDamageThreshold}}%.
                </div>
                <div
                  v-else-if="item.checkSum.status=='Border'"
                  class="status"
                  style="color :#F0A623;"
                >
                  <span class="side_text">{{item.name}}</span> Border, Total defects
                  <span
                    style="font-weight:bolder"
                  >{{Math.round(item.checkSum.total*100)/100}}%</span>
                  is close to threshold {{reports.averageCheckSum.threshold.totalDamageThreshold}}%
                </div>

                <div
                  v-else-if="item.checkSum.status=='Lot Failed'"
                  class="status"
                  style="color : #E74C3C;"
                >
                  <span class="side_text">{{item.name}}</span> Lot Failed, Total defects
                  <span
                    style="font-weight:bolder"
                  >{{Math.round(item.checkSum.total*100)/100}}%</span>
                  is above tolerance {{reports.averageCheckSum.threshold.tolerance}}%
                </div>
                <div
                  v-for="(allowance,idx) in reports.allowances[index].failedAllowances"
                  class="status"
                  style="color: rgb(231, 76, 60)"
                  :key="idx"
                >
                  <span class="side_text">{{item.name}}</span>
                  Allowance {{allowance.name}} failed with damage
                  <span
                    style="font-weight:bolder"
                  >{{Math.round(allowance.damage*100)/100}}%</span>
                  and serious Damage
                  <span
                    style="font-weight:bolder"
                  >{{Math.round(allowance.seriousDamage*100)/100}}%</span>
                </div>
              </div>
            </div>
            <!-- SIXTH CARD END -->
            <br />
            <!-- SEVENTH CARD IMAGES -->
            <div class="col-12 card">
              <div class="row">
                <div class="col-12">
                  <div class="flex table_heading">
                    <div class="col heading_2" style="margin-top:16px; ">Sample Images</div>
                  </div>
                </div>
              </div>
              <hr />
              <div class="row">
                <div class="col-12">
                  <table class="table table-bordered">
                    <thead class="back-color">
                      <th style="width:108px">Sample</th>
                      <th>Images</th>
                    </thead>
                    <tbody>
                      <tr v-for="(item, index) in imageUrls" v-bind:key="index">
                        <td>sample_{{index}}</td>
                        <td>
                          <div class="row" ref="imagerow">
                            <div class="m-2" v-for="(url, index) in item " :key="index">
                              <img
                                class="sample-images"
                                :key="index"
                                :src="url.url"
                                style=" border-radius:4px;margin:10px;  "
                              />
                              <ol type="1" class="new_ol">
                                <li
                                  class="list_style"
                                  v-for="(tag,index) in url.tags"
                                  :key="index"
                                >{{tag}}</li>
                              </ol>
                            </div>
                          </div>
                        </td>
                      </tr>
                    </tbody>
                  </table>
                </div>
              </div>
            </div>
            <!-- SEVENTH CARD END -->
          </div>
        </div>
        <br />
        <br />
        <div>
          <button @click="ConfirmReport" class="print_button col-2">Confirm</button>
          <button @click="ReturnToSample" class="download_button col-2">Edit</button>
        </div>
      </div>
    </div>
  </div>
</template>


<style scoped>
/* STYLING FOR BASIC INFO */
.table-Logo td {
  border: 0px;
}
td.tdleft {
  text-align: left;
  width: max-content;
  white-space: nowrap;
  padding: 2px;
  border: 0px;
}

.Agsift-logo {
  width: 130px;
}
.report-logo {
  width: 200px;
  text-align: center;
}
td.tdright {
  text-align: left;
  white-space: nowrap;
  width: max-content;
  padding: 2px;
  border: 0px;
}
.header-title {
  font-weight: 600;
}
.image_svg {
  width: 30px;
  height: 30px;
  color: #24c656;
  margin-right: 12px;
}
.table_heading {
  position: relative;
  display: flex;
  width: 100%;
  margin-bottom: 10px;
}
.table_heading .text {
  width: 200px;
  text-align: center;
  background: #ffa245;
  padding: 9px;
  color: #ffffff;
  border-radius: 30px;
}
.table_heading hr {
  width: 100%;
  color: #ffa245;
  border-color: #ffa245;
  margin-left: 4px;
  margin-top: 18px;
}

.button-submit {
  background: #ffffff;
  border: 1px solid #24c656;
  box-sizing: border-box;
  border-radius: 4px;
}
.nav-pills .nav-link.active.singleLink {
  background: transparent !important;
  font-size: 32px;
  color: #000000;
  text-align: left;
  width: 100%;
  padding: 0px;
}
.border-red {
  border: 1px solid #da0404 !important;
}
.border-green {
  border: 1px solid #3ac47b !important;
}
.border-yellow {
  border: 1px solid rgb(189, 183, 0) !important;
}
.width200 {
  width: 200px;
}
.sub {
  padding: 10px 16px;
  font-style: normal;
  font-weight: normal;
  font-size: 14px;
  line-height: 18px;

  /* identical to box height */

  color: #24c656;
}
.failed {
  color: #e74c3c;
}
.passed {
  color: #24c656;
}
.borderline {
  color: #f0a623;
}
#count_1 {
  padding-left: 0px;
}
.sub-hr {
  border: 1px solid #d7d9e0;
  width: 30%;
}
.back-color {
  background: #fafafa;
}
.sub_heading {
  font-style: normal;
  font-weight: 600;
  font-size: 14px;
  line-height: 18px;

  /* identical to box height */

  color: #29342e;
  padding-bottom: 16px;
}
table {
  border-radius: 4px;
}
.Approve_Message {
  color: #ffa245;
  /* color: #fff; */
  border-radius: 5px;
  /* bottom: 4%;
  left: 80%; */
  width: 9%;
  height: 35px;
}
.Approve_button {
  background: #24c656;
  position: relative;
  color: #fff;
  border-radius: 5px;
  bottom: 4%;
  left: 90%;
  width: 9%;
  height: 35px;
}

.print_button {
  background: #24c656;
  position: relative;
  color: #fff;
  border-radius: 5px;
  bottom: 4%;
  left: 90%;
  width: 9%;
  height: 35px;
}
.bold {
  font-weight: 600;
}
.purpleColor {
  color: #6037c0;
}
.side_text {
  font-weight: 600;
  margin-right: 24px;
  margin-left: 9px;
}
th {
  color: #29342e;
}
.table-bordered td,
.table-bordered th {
  border: 1px solid #aeb6bf;
  border-radius: 4px;
}
.table-bordered th {
  border: 1px solid rgb(202, 202, 202);
  white-space: normal; /*change-here*/
  font-size: 1.1rem;
}
.blank-row {
  border: 0px !important;
}
.td-defect {
  background-color: #ffa24520;
}
.td-defect-items {
  vertical-align: text-top;
  padding: 5px 0 5px 0;
}
.table-bordered td.damage_values {
  white-space: nowrap;
}
.status {
  color: #fff;

  padding: 7px;

  font-size: 16px;

  margin: 15px;

  opacity: 0.8;

  width: 650px;
}
.table-bordered td,
.table-bordered th {
  padding-left: 20px;
}
td,
th {
  text-align: left;
  vertical-align: middle;
}
.new_ol {
  padding-left: 37px;
}
.td-background {
  background-color: #f9f9f9;
}
.td-result {
  padding: 0px;
}
.check-sum {
  border: 1px solid #ffa245 !important;
}
.heading {
  font-weight: bold;
}
.margin {
  margin-right: 10px;
  margin-left: 10px;
}
.textdirection {
  transform: rotate(270deg);
}

.textdirection1 {
  transform: rotate(315deg);
}
.text-red {
  background-color: #ffeaea;
}
.text-green {
  background-color: #e3fff0;
}
.text-yellow {
  background-color: #ffffe0;
}
.report_table {
  /* changed here for styles*/
  height: 80vh;
  overflow: auto;
}
#show_2 {
  cursor: pointer;
  font-family: Source Sans Pro;
  font-style: normal;
  font-weight: normal;
  font-size: 12px;
  line-height: 15px;
  padding-left: 90%;
  color: #24c656;
  text-align: right;
  margin-right: 16px;
}
.comment-head {
  background-color: #3cb371 !important;
  border: none;
  width: 40px;
  height: 40px;
  border-radius: 50%;
  color: white;
  font-size: 17px;
  padding: 7px;
}
#show {
  font-family: Source Sans Pro;
  font-style: normal;
  font-weight: normal;
  font-size: 12px;
  line-height: 15px;
  padding-left: 13%;
  color: #24c656;
  cursor: pointer;
}
.comment-submit {
  height: 40px;
  width: 40px;
  margin: 0;
  border: 0;
  padding: 0;
}
.list_style {
  font-size: 14px;
  line-height: 18px;

  /* identical to box height */

  color: #29342e;
}
hr {
  border: 1px solid #cacaca;
  margin-bottom: 16px;
}
.comment-head-sm {
  background-color: #6037c0 !important;
  border: none;
  width: 35px;
  height: 35px;
  border-radius: 50%;
  color: white;
  font-size: 14px;
  padding: 7px;
  margin-top: 8px;
  text: center;
}
.comment-input {
  margin-left: 10px;
  height: 40px;
}
.comment-user {
  padding-left: 10px;
  font-weight: 600;
}
.comment-date {
  padding-left: 10px;
  font-weight: normal;
  font-size: 10px;

  color: #b4b4b4;
}
.comment-message {
  padding: 0px 10px 10px 10px;
  font-style: normal;
  font-weight: normal;
  font-size: 12px;
  line-height: 15px;

  color: #29342e;
}
.sample-images {
  height: 140px;
  width: 140px;
}
@print {
  .comment-add {
    display: none;
  }
}
#mid_table {
  margin-right: 2%;
}
#report {
  position: relative;
  left: 15px;
  top: 16px;
  font-weight: 600;
  font-size: 18px;
  line-height: 23px;
  color: #29342e;
  margin-bottom: 16px;
}
.ro {
  background-color: #f2f2f2;
}
#count_table {
  margin-left: 18%;
  font-style: normal;
  font-weight: normal;
  font-size: 10px;
  line-height: 13px;
  color: #b4b4b4;
}
.first_hr {
  border: 1px solid #cacaca;
}
.first_str {
  font-weight: 600;
  font-size: 14px;
  line-height: 18px;
  color: #29342e;
}
#inspection_role {
  font-style: normal;
  font-weight: normal;
  font-size: 24px;
  line-height: 30px;
  text-decoration-line: underline;
  margin-bottom: 24px;
  color: #29342e;
}
#approved_button {
  background: #effaff;
  border: 1px solid #11abeb;
  box-sizing: border-box;
  border-radius: 4px;
  width: 85px;
  height: 30px;
  margin-left: 12px;
  color: #11abeb;
  cursor: default;
}
#status_btn {
  font-family: Source Sans Pro;
  font-style: normal;
  font-weight: normal;
  font-size: 13px;
  line-height: 16px;

  color: #11abeb;
}
.table_top {
  margin-top: -26px;
}
#status_btn_pen {
  font-style: normal;
  font-weight: normal;
  font-size: 13px;
  line-height: 16px;

  color: #b4b4b4;
}
.box {
  border: 1px solid #b4b4b4;
  box-sizing: border-box;
  border-radius: 4px;
  margin-left: 16px;
}
#mid_td {
  padding-left: 49%;
}
#powerd_by {
  font-family: Source Sans Pro;
  font-style: normal;
  font-weight: normal;
  font-size: 18px;
  line-height: 23px;
  color: #24c656;
}
#pen_button {
  width: 77px;
  height: 30px;
  margin-left: 12px;
  background: #f9f9f9;
  border: 1px solid #b4b4b4;
  box-sizing: border-box;
  border-radius: 4px;
  cursor: default;
}
.heading_2 {
  font-style: normal;
  font-weight: normal;
  font-size: 16px;
  line-height: 20px;
  color: #29342e;
}
.count {
  padding-left: 17%;
}
.maxi {
  height: 240px;
  overflow: hidden;
}
.card {
  background: #ffffff;
  box-shadow: 0px 2px 20px rgba(0, 0, 0, 0.15);
  border-radius: 4px;
  width: 100%;
  padding-bottom: 16px;
  margin-top: 16px;
}
.border-new {
  border: 1px solid #cacaca;
}
.top_up {
  margin-top: -15px;
}
</style>

<script>
var docId;
import { Component, Prop, Vue } from "vue-property-decorator";
import { mapState, mapActions } from "vuex";
import jsPDF from "jspdf";
import html2canvas from "html2canvas";
import html2pdf from "html2pdf.js";
import { setTimeout } from "timers";

export default {
  name: "OnionSummary",
  data() {
    return {
      input_comment: "",
      showAllComments: false,
      showAllImages: false,
      maxCount: 150,
      remainingCount: 150,
      message: "",
      hasError: false,
      len: false,
      isMounted: false,
      image_row_width: 0
      //  imageKeys : this.getImageKeys()
    };
  },
  props: ["maximized"],
  computed: {
    noEditFlag() {
      return this.$store.state.nonEditFlag;
    },
    sample_num() {
      this.$store.state.reports.generalInfo.num_samples;
    },
    hideBasicRequirements() {
      var i = 0;
      this.reports.basicRequirements.forEach(item => {
        if (
          item.firmness !== "" ||
          item.cleanness !== "" ||
          item.shape !== "" ||
          item.maturity !== "" ||
          item.skinning !== ""
        ) {
          // console.log(" in hideBasicRequirements");
          i += 1;
        }
      });
      return i == 0;
    },
    docId() {
      return this.$route.params.docId;
    },
    userName() {
      return this.$store.state.username;
    },
    user() {
      return this.$store.state.user;
    },
    defects() {
      return this.getDefects();
      return [];
    },
    reports() {
      return this.$store.state.reports;
    },
    imageUrls() {
      return this.$store.state.reportUrl;
    },
    prevRoute() {
      if (
        !this.$store.state.prevRoute.includes(`/sample`) &&
        !this.$store.state.prevRoute.includes("/summary/")
      ) {
        if (this.noEditFlag)
          this.$router.push(`/app/secure/inspectionSummary/summary`);
        else
          this.$router.push(`/app/secure/inspectionTemplate/generalInfo/onion`);
      }
      return this.$store.state.prevRoute;
    }
  },
  watch: {
    //setTimeout(myFunction, 3000)
    maximized: function() {
      if (this.maximized) {
        // console.log("i am", this.maximized);
        setTimeout(() => {
          this.setImageNum(320);
        }, 500);
      } else {
        this.setImageNum(448);
      }
    },
    prevRoute(newVal, oldVal) {
      if (!newVal.includes(`/sample`)) {
        if (this.noEditFlag)
          this.$router.push(`/app/secure/inspectionSummary/summary`);
        else
          this.$router.push(`/app/secure/inspectionTemplate/generalInfo/onion`);
      }
    }
  },
  methods: {
    getDate(date) {
      var dt = new Date(date);
      var month = dt.getMonth();
      var months = [
        "Jan",
        "Feb",
        "Mar",
        "Apr",
        "May",
        "Jun",
        "Jul",
        "Aug",
        "Sep",
        "Oct",
        "Nov",
        "Dec"
      ];
      var day = dt.getDate();

      var year = dt.getFullYear();

      return months[month] + "-" + day + "-" + year;
    },
    getTime(time) {
      var dt = new Date(time);
      return `${dt.getHours()}:${dt.getMinutes()}`;
    },
    // countdown: function() {
    //   this.remainingCount = this.maxCount - this.input_comment.length;
    //   this.hasError = this.remainingCount < 0;
    // },
    setImageNum(num) {
      this.image_row_width = ~~((window.innerWidth - num) / 188);
    },
    getDefects() {
      let defects = [];
      for (let index in this.reports.defects) {
        let sample = this.reports.defects[index];
        // ROWTYPE:
        // 0= BlankROw
        // 1= With SampleName
        // 2= without SampleName with defect title
        // 3= with defect Total
        // 4= with Check Sum
        // 5= without defect title
        if (sample.values.length == 0)
          defects.push({
            rowType: 1,
            rowSpan: 1,
            samName: sample.name,
            samWT: sample.sample_weight,
            pulp_temperature: sample.pulp_temperature,
            defRowSpan: 1,
            DefItem: "No defect found",
            DItem: 0,
            SDItem: 0,
            TotItem: 0,
            status: true
          });
        for (let j in sample.values) {
          let item = sample.values[j];
          if (j == 0) {
            defects.push({
              rowType: 1,
              rowSpan: sample.values.length,
              samName: sample.name,
              samWT: sample.sample_weight,
              pulp_temperature: sample.pulp_temperature,
              defRowSpan: sample.values.length,
              DefItem: item.name,
              DItem: item.damage,
              SDItem: item.seriousDamage,
              TotItem: item.total,
              status: item.status
            });
          } else {
            defects.push({
              rowType: 5,
              DefItem: item.name,
              DItem: item.damage,
              SDItem: item.seriousDamage,
              TotItem: item.total,
              status: item.status
            });
          }
        }
        defects.push({
          rowType: 0
        });
        defects.push({
          rowType: 4,
          samName: sample.name,
          D: sample.checkSum.damage,
          SD: sample.checkSum.seriousDamage,
          Tot: sample.checkSum.total,
          status: sample.checkSum.status
        });
        defects.push({
          rowType: 0
        });
      }
      return defects;
    },
    async ReturnToSample(obj) {
      this.$store.commit("setUpdateMode", true);
      var logData = {
        user: this.$store.state.username,
        collection: "inspectionReport",
        mode: "return to sample",
        record: this.$route.params.docId,
        fields: [],
        newValue: [],
        oldValue: []
      };
      await this.$store.dispatch("AddUserLog", logData);
      if (this.noEditFlag)
        this.$router.push(
          `/app/secure/inspectionSummary/edit/samples/onion/${this.docId}/1`
        );
      else {
        this.$router.push(
          `/app/secure/inspectionTemplate/samples/onion/${this.docId}/1`
        );
      }
    },
    async ConfirmReport(obj) {
      if (!this.noEditFlag) {
        await this.$store.dispatch(
          "ConfirmOnionReport",
          this.$route.params.docId
        );
        await this.$store.dispatch(
          "ApproveOnionReport",
          this.$route.params.docId
        );
        this.$store.commit("setUpdateMode", false);

        this.$router.push(
          `/app/secure/inspectionTemplate/report/onion/${this.$route.params.docId}`
        );
      } else {
        this.$router.push(
          `/app/secure/inspectionSummary/report/onion/${this.$route.params.docId}`
        );
      }
    },
    Approve() {
      // console.log("here");
      this.$store.dispatch("showLoader", true);

      this.$store.dispatch("ApproveReport");
      this.reports;
      this.$store.dispatch("showLoader", false);
    },
    synchronizeCssStyles(src, destination, recursively) {
      // if recursively = true, then we assume the src dom structure and destination dom structure are identical (ie: cloneNode was used)

      // window.getComputedStyle vs document.defaultView.getComputedStyle
      // @TBD: also check for compatibility on IE/Edge
      destination.style.cssText = document.defaultView.getComputedStyle(
        src,
        ""
      ).cssText;

      if (recursively) {
        var vSrcElements = src.getElementsByTagName("*");
        var vDstElements = destination.getElementsByTagName("*");

        for (var i = vSrcElements.length; i--; ) {
          var vSrcElement = vSrcElements[i];
          var vDstElement = vDstElements[i];
          //          console.log(i + " >> " + vSrcElement + " :: " + vDstElement);
          vDstElement.style.cssText = document.defaultView.getComputedStyle(
            vSrcElement,
            ""
          ).cssText;
        }
      }
    }
  },
  mounted: async function() {
    this.$store.dispatch("showLoader", true);
    await this.$store.dispatch("getOnionSummary", this.docId);

    await this.$store.dispatch("getImages", {
      docId: this.docId,
      commodity: "onion"
    });
    this.reports;

    // await this.$store.dispatch("getImages", {docId:this.docId,commodity:'onion'});
    // await this.$store.dispatch("getImages", this.docId);
    this.setImageNum(this.maximized ? 320 : 448);
    this.isMounted = true;
    this.$store.dispatch("showLoader", false);
  },
  beforeDestroy: async function() {
    if (this.docId && this.$route.path.includes(this.docId)) {
      console.log("keep doc");
    } else if (!this.noEditFlag) {
      await this.$store.dispatch("deleteOnionReport", docId);
    }
  },
  created: function() {
    if (!this.$route.path.includes("inspectionSummary")) {
      this.$store.commit("changePathLabel", {
        view: "Create Inspection",
        categories: [
          { name: "General Inspection", focus: false },
          { name: "Sample Inspection", focus: false },
          { name: "Preview", focus: true },
          { name: "Report", focus: false }
        ]
      });
    } else {
      this.$store.commit("changePathLabel", {
        view: "Inspection Summary",
        categories: [{ name: "Report", focus: true }]
      });
    }
  }
};
</script>